export const ArrowIcon = (props) => {

  return (
    <span {...props}>
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.02083 4.69173L9.95 0.76256L11.2917 2.10423L6.02083 7.37506L0.75 2.10423L2.09167 0.76256L6.02083 4.69173Z"
        fill="#999999"
        />
      </svg>
    </span>
  )
}